import { ENDPOINT, MOOKENDPOINT } from "./endpoint/endpoint";
import { ROUTERS } from "./routers/routers";


export const CONSTANTS = {
  ENDPOINT,
  MOOKENDPOINT,
  ROUTERS
};